// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9ca54d70","796":"c542f551"}[chunkId] + ".chunk.js";
};